const getUserListViewFilters = (filters, userId) => {
  if (!filters) {
    return {};
  }
  const transformedFilters = {
    ...filters,
    tagIds: userId ? filters[`tagIds::${userId}`] : void 0
  };
  Object.keys(transformedFilters).forEach((key) => {
    if (key.startsWith("tagIds::") && key in transformedFilters) {
      delete transformedFilters[key];
    }
  });
  return transformedFilters;
};

export { getUserListViewFilters };
//# sourceMappingURL=getUserListViewPreferences.js.map
